import React, { useState, useMemo, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@material-ui/core';
import { isEmpty, isArray } from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';

import { Spinner, Table } from '~/components';
import { number } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';

export default function GravarDialog({
  valueProp,
  open,
  mensagem,
  titulo,
  textoBtnOK,
  textoBtnCancel,
  onClose,
  modal,
  arquivo,
}) {
  const [value, setValue] = React.useState(valueProp);
  const radioGroupRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isGravandoDados, setIsGravandoDados] = useState(false);

  const [planilhaClienteErro, setPlanilhaClienteErro] = useState([]);

  const cellsHeader = useMemo(
    () => [
      { id: 'planilha', label: 'Planilha' },
      // { id: 'campo', label: 'Campo' },
      // { id: 'linha', label: 'Linha' },
      { id: 'erro', label: 'Erro' },
    ],
    []
  );

  React.useEffect(() => {
    if (!open) {
      setIsGravandoDados(false);
      setValue(valueProp);
      setPlanilhaClienteErro([]);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    try {
      setIsLoading(true);
      onClose();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handleOk = async () => {
    try {
      setIsGravandoDados(true);
      setPlanilhaClienteErro([]);

      const { data } = await api.put(
        `/uploadplanilhacliente/gravar/${arquivo}`
      );

      setIsGravandoDados(false);

      console.log(data);

      if (!isEmpty(data)) {
        toast.error('Falha na gravação da planilha!');
        setPlanilhaClienteErro(data);

        return;
      }
      toast.success('A planilha foi gravada na base de dados!');
    } catch (err) {
      setIsGravandoDados(false);
      setPlanilhaClienteErro([]);
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
    }

    const recordResult = {
      acao: value,
    };

    try {
      setIsLoading(true);
      onClose(recordResult);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div>
      ) : (
        ''
      )}

      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth={modal}
        onEntering={handleEntering}
        aria-labelledby="confirmation-dialog-title"
        open={open}
        PaperProps={{
          style: {
            height: '40vh', // 30 Define a altura do dialog
            width: '45vh', // 35
            maxHeight: 'none', // Remove o limite de altura
          },
        }}

        // {...other}
      >
        {/* <DialogTitle id="confirmation-dialog-title">Confirmar</DialogTitle> */}
        <DialogTitle id="confirmation-dialog-title">{titulo}</DialogTitle>
        <DialogContent dividers>
          {/* <span>{mensagem}</span> */}
          <br />

          <S.WrapperCab>
            {isGravandoDados ? (
              <div style={{ zIndex: 999999 }}>
                Aguarde gravando....
                <Spinner loading />
              </div>
            ) : (
              <div>
                {isEmpty(planilhaClienteErro) ? (
                  <h5>Clique no botão gravar para gravar a planilha!</h5>
                ) : (
                  <>
                    <h5 style={{ color: 'red' }}>
                      Não foi possível gravar a planilha! ERRRO!
                    </h5>
                    <Table
                      size="small"
                      cells={cellsHeader}
                      data={planilhaClienteErro}
                      loading={loading}
                      paginate={99999}
                      maxHeight={300}
                      showPagination={false}
                    />
                  </>
                )}
              </div>
            )}
          </S.WrapperCab>
          <br />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleOk}
            color="primary"
            variant="outlined"
            disabled={isGravandoDados}
          >
            {' '}
            {textoBtnOK}{' '}
          </Button>
          <Button
            autoFocus
            onClick={handleCancel}
            color="secondary"
            variant="outlined"
          >
            {' '}
            {textoBtnCancel}{' '}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

GravarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  valueProp: PropTypes.string.isRequired,
  mensagem: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  textoBtnOK: PropTypes.string.isRequired,
  textoBtnCancel: PropTypes.string.isRequired,
  modal: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']),
};

GravarDialog.defaultProps = {
  valueProp: '',
  open: false,
  mensagem: '',
  titulo: 'CONFIRMAR',
  textoBtnOK: 'Ok',
  textoBtnCancel: 'Cancel',
  modal: 'xs',
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};
